<template>
  <div style="height: 100%;">
    <v-toolbar v-if="$route.name !== 'Feedback Show'" app fixed color="primary" flat dark>
      <v-btn @click="$router.go(-1)" icon >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$route.name !== 'Manage User'">{{$route.name}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-avatar
          tile="tile"
          size="avatarSize"
          color="transparent"
        >
          <!-- <img class="avatar" src="/assets/logo.png" alt="avatar"> -->
      </v-avatar>
    </v-toolbar>

    <v-content style="height: 100%;">
      <v-container :class="{'no-padding': $route.meta.noPadding}" grid-list-lg fill-height fluid>
      <slot />
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/simple.vue